import { Pipe, PipeTransform } from '@angular/core';
import { SigningAction } from '../../core/services/signing.service';

@Pipe({
  name: 'signingActionToPlaceLabel'
})
export class SigningActionToPlaceLabelPipe implements PipeTransform {

  transform(signingAction: SigningAction): string {
    if (signingAction === SigningAction.COLLECTION || signingAction === SigningAction.PICKUP_FROM_INTERMEDIATE) {
      return 'role.placeoftakingover';
    }
    return 'role.placeofdelivery';
  }
}
